<template>
  <div>
    <div style="display: flex;justify-content: space-between;padding-right: 45px;">
      <div style="display: flex;align-items: center;">
        <h3 style="margin-right: 120px;width: 200px;"># {{ isAnonymous ? '小秘密列表' : '帖子列表' }}</h3>
      </div>
      <div>
        <el-input v-model.trim="selectInputData" style="width: 200px;" size="small"
          placeholder="输入用户信息查询"></el-input>
        <el-button style="margin-left: 2px;" icon="el-icon-search" size="small" type="primary"
          @click="seletcSubmitFn"></el-button>
        <el-button icon="el-icon-s-check" size="small" style="margin-left: 50px;"
          @click="batchSubCheckFn">批量提交审核</el-button>
      </div>
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="全部" name="0"></el-tab-pane>
      <el-tab-pane label="待审核" name="1"></el-tab-pane>
      <el-tab-pane label="已通过" name="2"></el-tab-pane>
      <el-tab-pane label="未通过" name="3"></el-tab-pane>
      <el-tab-pane label="被举报下架" name="4"></el-tab-pane>
      <el-tab-pane label="审核异常" name="5"></el-tab-pane>
    </el-tabs>
    <el-table class="content-table" @selection-change="handleSelectionChange" :data="contentTableData" style="width: 100%">
      <el-table-column align="center" type="selection" width="55">
      </el-table-column>

      <el-table-column prop="contentId" label="帖子ID" width="90" align="center">
      </el-table-column>

      <el-table-column label="头像" width="90" align="center">
        <template slot-scope="scope">
          <el-image v-if="scope.row.userPicture" class="user-avatar" :src="scope.row.userPicture" fit="cover"
            @click="openUserDetail(scope.row)">
          </el-image>
          <div v-else class="user-avatar avatar-placeholder" @click="openUserDetail(scope.row)">
            <i class="el-icon-user"></i>
          </div>
        </template>
      </el-table-column>

      <el-table-column label="用户昵称" align="center" show-overflow-tooltip>
        <template slot-scope="scope">
          <el-button type="text" class="user-name-link" @click="openUserDetail(scope.row)">
            {{ scope.row.nickName || '--' }}
          </el-button>
          <div v-if="isAnonymous && scope.row.anonym" class="anonymous-name">{{ scope.row.anonym }}</div>
        </template>
      </el-table-column>

      <el-table-column prop="circleName" label="所属圈子" width="130" align="center">
        <template slot-scope="scope">
          <el-button type="text" class="circle-link" @click="openCircleDetail(scope.row)">
            {{ scope.row.circleName || '--' }}
          </el-button>
        </template>
      </el-table-column>

      

      <el-table-column prop="contentType" label="类型" width="80" align="center">
        <template slot-scope="scope">
          <span
            :style="{ color: scope.row.contentType == 0 ? '#3bb4f2' : scope.row.contentType == 1 ? '#5eb95e' : '#F37B1D' }">
            {{ scope.row.contentType == 0 ? '文图' : scope.row.contentType == 1 ? '视频' : '语音' }}
          </span>
        </template>
      </el-table-column>

      <el-table-column prop="contentTitle" show-overflow-tooltip label="帖子标题" min-width="260" align="center">
        <template slot-scope="scope">
          <el-button type="text" class="title-link" @click="openPostDetail(scope.row)">
            {{ scope.row.contentTitle || '--' }}
          </el-button>
        </template>
      </el-table-column>

      <el-table-column prop="createTime" label="发帖时间" width="180" align="center">
      </el-table-column>

      <el-table-column prop="recommendationStatus" label="置顶" width="100" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.recommendationStatus" :disabled="scope.row.contentState != 1"
            :active-value="1" :inactive-value="0" @change="switchChange(scope.row, $event)">
          </el-switch>
        </template>
      </el-table-column>

      <el-table-column prop="contentState" label="审核状态" width="118" align="center">
        <template slot-scope="scope">
          <el-tag :type="contentStateTag(scope.row.contentState)">
            {{ contentStateText(scope.row.contentState) }}
          </el-tag>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="120" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" plain @click="openPostDetail(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div style="text-align: right;margin: 20px 20px 0 0;">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page.sync="searchForm.pageNum" :page-sizes="[10, 20, 30, 50]" :page-size="searchForm.pageSize"
        layout="total, sizes, prev, pager, next" :total="total_pages">
      </el-pagination>
    </div>

    <el-dialog title="" id="el-dialog" :append-to-body="true" :visible.sync="batchCenterDialogVisible" width="30%"
      center>
      <span style="margin-right: 24px;">帖子审核状态: </span>
      <el-select v-model="dataForm.contentState" placeholder="请选择">
        <el-option label="通过" :value="1"></el-option>
        <el-option label="下架" :value="2"></el-option>
        <el-option label="删除" :value="3"></el-option>
      </el-select>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchCenterDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="batchSubmitCheckFn">确 定</el-button>
      </span>
    </el-dialog>

    <UserDetailDialog ref="userDetailRef" />
    <CircleDetailDialog ref="circleDetailRef" />
    <PostDetailDialog ref="postDetailRef" @success="handlePostUpdated" />
  </div>
</template>

<script>
import { GetContentListApi, setContentExamineResult } from '@/api/user'
import { topPostApi } from '@/api/virtual'
import UserDetailDialog from '@/components/UserDetailDialog.vue'
import CircleDetailDialog from '@/components/CircleDetailDialog.vue'
import PostDetailDialog from '@/components/PostDetailDialog.vue'
export default {
  name: 'conTent',
  components: {
    UserDetailDialog,
    CircleDetailDialog,
    PostDetailDialog
  },
  props: {
    circleIdVal: {
      type: String,
      default: ''
    },
    isAnonymous: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      searchForm: { pageNum: 1, pageSize: 10, circleId: '', userid: '', postType: '' },
      dataForm: {contentState:null},
      contentTableData: [],
      total_pages: 0,
      activeName: '0',
      multipleSelection: [],
      selectContentStateData: '',
      batchCenterDialogVisible: false,
      selectInputData: '',
      selectInputDataShow: { show: false, newVal: '' },
      pushData: false
    }
  },
  watch: {
    activeName() {
      this.selectInputDataShow.show = false
    }
  },
  mounted() {
    if (this.circleIdVal) {
      this.searchForm.circleId = this.circleIdVal
    }
    if (this.$route.query.userid) {
      this.searchForm.userid = this.$route.query.userid
    }
    if (this.isAnonymous) {
      this.searchForm.isAnonymous = true
    }
    this.getList()
  },
  methods: {
    switchChange(row, val) {
      console.log('123', row, val);
      topPostApi(row.contentId).then(res => {
        if (res.code == 200) {
          this.$message({ type: 'success', message: '操作成功' });
          this.getList()
        } else {
          this.$message({ type: 'error', message: res.msg });
        }
      }).catch(err => this.$message({ type: 'error', message: '请求失败, 请重试' }));
    },
    handleCurrentChange(number) {
      this.searchForm.pageNum = number;
      this.getList();
    },
    handleSizeChange(size) {
      if (this.total_pages >= size) {
        this.searchForm.pageSize = size;
        this.getList();
      }
    },
    getList() {
      GetContentListApi(this.searchForm).then(res => {
        if (res.code == 200) {
          this.contentTableData = res.data.records;
          this.total_pages = res.data.total;
        } else {
          this.$message.error(res.msg ? res.msg : '获取帖子列表失败');
        }
      }).catch(err => this.$message.error(err ? err : '请求失败, 请重试'));
    },
    // 切换导航栏
    handleClick() {
      switch (this.activeName) {
        case '0':
          this.searchForm.postType = ''
          break;
        case '1':
          this.searchForm.postType = '0'
          break;
        case '2':
          this.searchForm.postType = '1'
          break;
        case '3':
          this.searchForm.postType = '2'
          break;
        case '4':
          this.searchForm.postType = '3'
          break;
        case '5':
          this.searchForm.postType = '4'
          break;
        default:
          this.searchForm.postType = ''
          break;
      }
      this.searchForm.pageNum = 1;
      this.getList();
    },
    contentStateText(state) {
      const stateMap = {
        0: '待审核',
        1: '通过',
        2: '下架',
        3: '删除',
        4: '审核异常'
      }
      return stateMap[state] || '待审核'
    },
    contentStateTag(state) {
      if (state == 1) return 'success'
      if (state == 4) return 'info'
      if (state == 2 || state == 3) return 'danger'
      return 'warning'
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    openPostDetail(row) {
      this.$refs.postDetailRef.open(row)
    },
    handlePostUpdated(updated) {
      const index = this.contentTableData.findIndex(item => item.contentId === updated.contentId)
      if (index === -1) return
      this.$set(this.contentTableData, index, {
        ...this.contentTableData[index],
        ...updated
      })
    },
    openUserDetail(row) {
      this.$refs.userDetailRef.open(row.userid, {
        name: row.nickName,
        nickName: row.nickName,
        userPicture: row.userPicture
      })
    },
    openCircleDetail(row) {
      this.$refs.circleDetailRef.open(row.circleId, {
        name: row.circleName,
        circleName: row.circleName
      })
    },
    // 批量审核对话框打开
    batchSubCheckFn() {
      if (this.multipleSelection.length == 0) {
        this.$message({
          message: '请选择需要修改的帖子',
          type: 'warning'
        })
      } else {
        this.batchCenterDialogVisible = true
      }
    },
    // 批量审核提交事件
    async batchSubmitCheckFn() {
      if (this.multipleSelection.length === 0 || !this.multipleSelection) return
      let idList = this.multipleSelection.map(item => item.contentId)
      this.dataForm.contentIds = idList

      try {
        if (this.dataForm.contentState) {

          const resss = await setContentExamineResult(this.dataForm)
          console.log(resss, 'resss')
          this.batchCenterDialogVisible = false;
          this.getList();
        } else {
          this.$message({
            message: '请选择需要修改的状态',
            type: 'warning'
          })
        }
      } catch { }
    },
    // 搜索帖子按钮被单击
    async seletcSubmitFn() {
      this.searchForm.userid = this.selectInputData
      this.getList()
    }
  }
}
</script>

<style scoped lang="scss">
.user-avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  cursor: pointer;
}

.avatar-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e9eef3;
  color: #909399;
}

.user-name-link {
  max-width: 92px;
  padding: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 18px;
  vertical-align: middle;
}

.anonymous-name {
  max-width: 92px;
  margin-top: 2px;
  margin-right: auto;
  margin-left: auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #909399;
  font-size: 12px;
}

.circle-link {
  max-width: 112px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.title-link {
  max-width: 100%;
  padding: 0;
  overflow: hidden;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.content-table {
  ::v-deep .el-table__cell {
    padding: 8px 0;
  }
}
</style>
